import React, { useContext, useState } from "react";
import { Box } from "@mui/material";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import DescriptionOutlinedIcon from "@mui/icons-material/DescriptionOutlined";
import GridOnIcon from "@mui/icons-material/GridOn";
import CropOriginalIcon from "@mui/icons-material/CropOriginal";
import VideoLabelIcon from "@mui/icons-material/VideoLabel";
import LinkIcon from "@mui/icons-material/Link";

import { findQueryParameter, SiteContext } from "gatsby-frontend";
import { DownloadModal } from "./../";

function Resources({ id, media }) {
	const [uuid, setUuid] = useState(null);
	// const [error, setError] = useState(null);
	const handleModal = (_uuid = null) => setUuid(_uuid);
	const { location } = useContext(SiteContext);

	return (
		<>
			{media.map((item) => {
				let Icon;
				switch (item.format) {
					case "pdf":
						Icon = PictureAsPdfIcon;
						break;
					case "jpg":
					case "png":
						Icon = CropOriginalIcon;
						break;
					case "ppt":
					case "pptx":
						Icon = VideoLabelIcon;
						break;
					case "xls":
					case "xlsx":
						Icon = GridOnIcon;
						break;
					case "url":
						Icon = LinkIcon;
						break;
					default:
						Icon = DescriptionOutlinedIcon;
						break;
				}
				const attrs = {};
				if (item.url.includes("http")) {
					attrs.rel = "noreferrer";
				}
				const extras = item.external
					? { rel: "noopener noreferrer", target: "_blank" }
					: {};

				if (item.url.includes("download?media") && !item.external) {
					attrs.onClick = (e) => {
						e.preventDefault();
						let _search = item.url.includes("?")
							? `?${item.url.split("?")[1]}`
							: null;
						if (handleModal && _search) {
							let _uuid = findQueryParameter(_search, "media");
							handleModal(_uuid);
						} else {
							let referrer = location.search
								? `${location.pathname}${location.search}`
								: location.pathname;
							navigate(item.url, { state: { referrer } });
						}
					};
				}

				return (
					<Box
						component="a"
						key={item.id}
						href={item.url}
						className={`media-item`}
						{...attrs}
						{...extras}
						sx={(theme) => ({
							display: "flex",
							justifyContent: "space-between",
							alignItems: "center",
							textDecoration: "none",
							fontSize: "1.1em",
							width: "100%",
							color: theme.palette.link.main,
							"& > span": {
								display: "flex",
								alignItems: "center",
								"& .title": {
									display: "block",
									wordBreak: "break-all",
								},
							},
							"& + .media-item": {
								paddingTop: theme.spacing(1),
								marginTop: theme.spacing(1),
								borderTop: `${theme.palette.grey.dark} 1px solid`,
							},
							"& .MuiSvgIcon-root": {
								fill: theme.palette.link.hover,
							},
							"&:focus, &:hover, &:active": {
								color: theme.palette.link.hover,
								textDecoration: "underline",
								"& .MuiSvgIcon-root": {
									fill: theme.palette.link.hover,
								},
							},
						})}
					>
						<span>
							<Icon
								className={`format-${item.format}`}
								sx={(theme) => ({
									width: 30,
									height: 35,
									marginRight: theme.spacing(1),
									fill: theme.palette.link.main,
								})}
							/>{" "}
							<span className="title">{item.title}</span>
						</span>
					</Box>
				);
			})}
			<DownloadModal uuid={uuid} setUuid={setUuid} />
		</>
	);
}

export default Resources;
